export default { time: 1764842394982 }



// WEBPACK FOOTER //
// ./src/buildTime.js